 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import ONCEAMARINE_FRONTCOVER from '@/components/OnceAMarine_frontcover'
 import ONCEAMARINE_ADVANCE from '@/components/OnceAMarine_advance'
 import ONCEAMARINE_TITLE from '@/components/OnceAMarine_title'
 import ONCEAMARINE_COPYRIGHT from '@/components/OnceAMarine_copyright'
 import ONCEAMARINE_DEDICATION from '@/components/OnceAMarine_dedication'
 import ONCEAMARINE_TOC from '@/components/OnceAMarine_toc'
 import ONCEAMARINE_MAPS from '@/components/OnceAMarine_Maps'
 import ONCEAMARINE_FOREWORD from '@/components/OnceAMarine_foreword'
 import ONCEAMARINE_COLLABORATOR from '@/components/OnceAMarine_collaborator'
 import ONCEAMARINE_INTRODUCTION from '@/components/OnceAMarine_introduction'
 import ONCEAMARINE_ACKNOWLEDGMENTS from '@/components/OnceAMarine_acknowledgments'
 import ONCEAMARINE_PART1 from '@/components/OnceAMarine_part1'
 import ONCEAMARINE_CHAPTER1 from '@/components/OnceAMarine_chapter1'
 import ONCEAMARINE_CHAPTER2 from '@/components/OnceAMarine_chapter2'
 import ONCEAMARINE_CHAPTER3 from '@/components/OnceAMarine_chapter3'
 import ONCEAMARINE_CHAPTER4 from '@/components/OnceAMarine_chapter4'
 import ONCEAMARINE_CHAPTER5 from '@/components/OnceAMarine_chapter5'
 import ONCEAMARINE_CHAPTER6 from '@/components/OnceAMarine_chapter6'
 import ONCEAMARINE_CHAPTER7 from '@/components/OnceAMarine_chapter7'
 import ONCEAMARINE_CHAPTER8 from '@/components/OnceAMarine_chapter8'
 import ONCEAMARINE_CHAPTER9 from '@/components/OnceAMarine_chapter9'
 import ONCEAMARINE_CHAPTER10 from '@/components/OnceAMarine_chapter10'
 import ONCEAMARINE_CHAPTER11 from '@/components/OnceAMarine_chapter11'
 import ONCEAMARINE_CHAPTER12 from '@/components/OnceAMarine_chapter12'
 import ONCEAMARINE_CHAPTER13 from '@/components/OnceAMarine_chapter13'
 import ONCEAMARINE_CHAPTER14 from '@/components/OnceAMarine_chapter14'
 import ONCEAMARINE_CHAPTER15 from '@/components/OnceAMarine_chapter15'
 import ONCEAMARINE_CHAPTER16 from '@/components/OnceAMarine_chapter16'
 import ONCEAMARINE_CHAPTER17 from '@/components/OnceAMarine_chapter17'
 import ONCEAMARINE_CHAPTER18 from '@/components/OnceAMarine_chapter18'
 import ONCEAMARINE_CHAPTER19 from '@/components/OnceAMarine_chapter19'
 import ONCEAMARINE_CHAPTER20 from '@/components/OnceAMarine_chapter20'
 import ONCEAMARINE_CHAPTER21 from '@/components/OnceAMarine_chapter21'
 import ONCEAMARINE_CHAPTER22 from '@/components/OnceAMarine_chapter22'
 import ONCEAMARINE_CHAPTER23 from '@/components/OnceAMarine_chapter23'
 import ONCEAMARINE_CHAPTER24 from '@/components/OnceAMarine_chapter24'
 import ONCEAMARINE_CHAPTER25 from '@/components/OnceAMarine_chapter25'
 import ONCEAMARINE_CHAPTER26 from '@/components/OnceAMarine_chapter26'
 import ONCEAMARINE_CHAPTER27 from '@/components/OnceAMarine_chapter27'
 import ONCEAMARINE_CHAPTER28 from '@/components/OnceAMarine_chapter28'
 import ONCEAMARINE_CHAPTER29 from '@/components/OnceAMarine_chapter29'
 import ONCEAMARINE_CHAPTER30 from '@/components/OnceAMarine_chapter30'
 import ONCEAMARINE_CHAPTER31 from '@/components/OnceAMarine_chapter31'
 import ONCEAMARINE_CHAPTER32 from '@/components/OnceAMarine_chapter32'
 import ONCEAMARINE_CHAPTER3201 from '@/components/OnceAMarine_chapter3201'
 import ONCEAMARINE_CHAPTER3202 from '@/components/OnceAMarine_chapter3202'
 import ONCEAMARINE_CHAPTER3203 from '@/components/OnceAMarine_chapter3203'
 import ONCEAMARINE_CHAPTER3204 from '@/components/OnceAMarine_chapter3204'
 import ONCEAMARINE_CHAPTER3205 from '@/components/OnceAMarine_chapter3205'
 import ONCEAMARINE_CHAPTER3206 from '@/components/OnceAMarine_chapter3206'
 import ONCEAMARINE_CHAPTER3207 from '@/components/OnceAMarine_chapter3207'
 import ONCEAMARINE_CHAPTER3208 from '@/components/OnceAMarine_chapter3208'
 import ONCEAMARINE_CHAPTER3209 from '@/components/OnceAMarine_chapter3209'
 import ONCEAMARINE_CHAPTER3210 from '@/components/OnceAMarine_chapter3210'
 import ONCEAMARINE_CHAPTER3211 from '@/components/OnceAMarine_chapter3211'
 import ONCEAMARINE_CHAPTER3212 from '@/components/OnceAMarine_chapter3212'
 import ONCEAMARINE_CHAPTER3213 from '@/components/OnceAMarine_chapter3213'
 import ONCEAMARINE_CHAPTER3214 from '@/components/OnceAMarine_chapter3214'
 import ONCEAMARINE_CHAPTER3215 from '@/components/OnceAMarine_chapter3215'
 import ONCEAMARINE_CHAPTER3216 from '@/components/OnceAMarine_chapter3216'
 import ONCEAMARINE_CHAPTER3217 from '@/components/OnceAMarine_chapter3217'
 import ONCEAMARINE_CHAPTER3218 from '@/components/OnceAMarine_chapter3218'
 import ONCEAMARINE_CHAPTER3219 from '@/components/OnceAMarine_chapter3219'
 import ONCEAMARINE_CHAPTER3220 from '@/components/OnceAMarine_chapter3220'
 import ONCEAMARINE_CHAPTER3221 from '@/components/OnceAMarine_chapter3221'
 import ONCEAMARINE_CHAPTER3222 from '@/components/OnceAMarine_chapter3222'
 import ONCEAMARINE_CHAPTER3223 from '@/components/OnceAMarine_chapter3223'
 import ONCEAMARINE_CHAPTER3224 from '@/components/OnceAMarine_chapter3224'
 import ONCEAMARINE_CHAPTER3225 from '@/components/OnceAMarine_chapter3225'
 import ONCEAMARINE_CHAPTER3226 from '@/components/OnceAMarine_chapter3226'
 import ONCEAMARINE_CHAPTER3227 from '@/components/OnceAMarine_chapter3227'
 import ONCEAMARINE_CHAPTER3228 from '@/components/OnceAMarine_chapter3228'
 import ONCEAMARINE_CHAPTER3229 from '@/components/OnceAMarine_chapter3229'
 import ONCEAMARINE_CHAPTER3230 from '@/components/OnceAMarine_chapter3230'
 import ONCEAMARINE_CHAPTER3231 from '@/components/OnceAMarine_chapter3231'
 import ONCEAMARINE_CHAPTER3232 from '@/components/OnceAMarine_chapter3232'
 import ONCEAMARINE_CHAPTER3233 from '@/components/OnceAMarine_chapter3233'
 import ONCEAMARINE_CHAPTER3234 from '@/components/OnceAMarine_chapter3234'
 import ONCEAMARINE_CHAPTER3235 from '@/components/OnceAMarine_chapter3235'
 import ONCEAMARINE_CHAPTER3236 from '@/components/OnceAMarine_chapter3236'
 import ONCEAMARINE_CHAPTER3237 from '@/components/OnceAMarine_chapter3237'
 import ONCEAMARINE_CHAPTER3238 from '@/components/OnceAMarine_chapter3238'
 import ONCEAMARINE_CHAPTER33 from '@/components/OnceAMarine_chapter33'
 import ONCEAMARINE_CHAPTER34 from '@/components/OnceAMarine_chapter34'
 import ONCEAMARINE_CHAPTER35 from '@/components/OnceAMarine_chapter35'
 import ONCEAMARINE_CHAPTER36 from '@/components/OnceAMarine_chapter36'
 import ONCEAMARINE_CHAPTER37 from '@/components/OnceAMarine_chapter37'
 import ONCEAMARINE_CHAPTER38 from '@/components/OnceAMarine_chapter38'
 import ONCEAMARINE_CHAPTER39 from '@/components/OnceAMarine_chapter39'
 import ONCEAMARINE_CHAPTER40 from '@/components/OnceAMarine_chapter40'
 import ONCEAMARINE_CHAPTER41 from '@/components/OnceAMarine_chapter41'
 import ONCEAMARINE_CHAPTER42 from '@/components/OnceAMarine_chapter42'
 import ONCEAMARINE_CHAPTER43 from '@/components/OnceAMarine_chapter43'
 import ONCEAMARINE_CHAPTER44 from '@/components/OnceAMarine_chapter44'
 import ONCEAMARINE_PART2 from '@/components/OnceAMarine_part2'
 import ONCEAMARINE_CHAPTER45 from '@/components/OnceAMarine_chapter45'
 import ONCEAMARINE_CHAPTER46 from '@/components/OnceAMarine_chapter46'
 import ONCEAMARINE_CHAPTER47 from '@/components/OnceAMarine_chapter47'
 import ONCEAMARINE_CHAPTER48 from '@/components/OnceAMarine_chapter48'
 import ONCEAMARINE_CHAPTER49 from '@/components/OnceAMarine_chapter49'
 import ONCEAMARINE_CHAPTER50 from '@/components/OnceAMarine_chapter50'
 import ONCEAMARINE_CHAPTER5001 from '@/components/OnceAMarine_chapter5001'
 import ONCEAMARINE_CHAPTER5002 from '@/components/OnceAMarine_chapter5002'
 import ONCEAMARINE_CHAPTER51 from '@/components/OnceAMarine_chapter51'
 import ONCEAMARINE_CHAPTER52 from '@/components/OnceAMarine_chapter52'
 import ONCEAMARINE_CHAPTER53 from '@/components/OnceAMarine_chapter53'
 import ONCEAMARINE_CHAPTER54 from '@/components/OnceAMarine_chapter54'
 import ONCEAMARINE_CHAPTER55 from '@/components/OnceAMarine_chapter55'
 import ONCEAMARINE_CHAPTER5501 from '@/components/OnceAMarine_chapter5501'
 import ONCEAMARINE_CHAPTER5502 from '@/components/OnceAMarine_chapter5502'
 import ONCEAMARINE_CHAPTER56 from '@/components/OnceAMarine_chapter56'
 import ONCEAMARINE_CHAPTER57 from '@/components/OnceAMarine_chapter57'
 import ONCEAMARINE_CHAPTER58 from '@/components/OnceAMarine_chapter58'
 import ONCEAMARINE_CHAPTER59 from '@/components/OnceAMarine_chapter59'
 import ONCEAMARINE_CHAPTER60 from '@/components/OnceAMarine_chapter60'
 import ONCEAMARINE_CHAPTER6001 from '@/components/OnceAMarine_chapter6001'
 import ONCEAMARINE_CHAPTER6002 from '@/components/OnceAMarine_chapter6002'
 import ONCEAMARINE_EPILOGUE from '@/components/OnceAMarine_epilogue'
 import ONCEAMARINE_EPILOGUE01 from '@/components/OnceAMarine_epilogue01'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/OnceAMarine_frontcover",
 			"name" : "OnceAMarine_frontcover",
 			"component" : ONCEAMARINE_FRONTCOVER
 		},
 		{
 			"path" : "/OnceAMarine_advance",
 			"name" : "OnceAMarine_advance",
 			"component" : ONCEAMARINE_ADVANCE
 		},
 		{
 			"path" : "/OnceAMarine_title",
 			"name" : "OnceAMarine_title",
 			"component" : ONCEAMARINE_TITLE
 		},
 		{
 			"path" : "/OnceAMarine_copyright",
 			"name" : "OnceAMarine_copyright",
 			"component" : ONCEAMARINE_COPYRIGHT
 		},
 		{
 			"path" : "/OnceAMarine_dedication",
 			"name" : "OnceAMarine_dedication",
 			"component" : ONCEAMARINE_DEDICATION
 		},
 		{
 			"path" : "/OnceAMarine_toc",
 			"name" : "OnceAMarine_toc",
 			"component" : ONCEAMARINE_TOC
 		},
 		{
 			"path" : "/OnceAMarine_Maps",
 			"name" : "OnceAMarine_Maps",
 			"component" : ONCEAMARINE_MAPS
 		},
 		{
 			"path" : "/OnceAMarine_foreword",
 			"name" : "OnceAMarine_foreword",
 			"component" : ONCEAMARINE_FOREWORD
 		},
 		{
 			"path" : "/OnceAMarine_collaborator",
 			"name" : "OnceAMarine_collaborator",
 			"component" : ONCEAMARINE_COLLABORATOR
 		},
 		{
 			"path" : "/OnceAMarine_introduction",
 			"name" : "OnceAMarine_introduction",
 			"component" : ONCEAMARINE_INTRODUCTION
 		},
 		{
 			"path" : "/OnceAMarine_acknowledgments",
 			"name" : "OnceAMarine_acknowledgments",
 			"component" : ONCEAMARINE_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/OnceAMarine_part1",
 			"name" : "OnceAMarine_part1",
 			"component" : ONCEAMARINE_PART1
 		},
 		{
 			"path" : "/OnceAMarine_chapter1",
 			"name" : "OnceAMarine_chapter1",
 			"component" : ONCEAMARINE_CHAPTER1
 		},
 		{
 			"path" : "/OnceAMarine_chapter2",
 			"name" : "OnceAMarine_chapter2",
 			"component" : ONCEAMARINE_CHAPTER2
 		},
 		{
 			"path" : "/OnceAMarine_chapter3",
 			"name" : "OnceAMarine_chapter3",
 			"component" : ONCEAMARINE_CHAPTER3
 		},
 		{
 			"path" : "/OnceAMarine_chapter4",
 			"name" : "OnceAMarine_chapter4",
 			"component" : ONCEAMARINE_CHAPTER4
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js